@if (isIndicatorActiv()) {
  <div class="loading_indicator">
    <adcl-loading-spinner class="custom" [size]="24" [direction]="'horizontal'"></adcl-loading-spinner>
  </div>
}
